import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)`
  width: 18px;
  height: 18px;
  color: #4a90e2;
`

const CircleRightArrow = ({ title = 'Add', ...rest }: IconProps) => (
  <StyledIcon viewBox="0 0 16 16" title={title} {...rest}>
    <g transform="translate(1 1)" stroke="currentColor" fill="none" fillRule="evenodd">
      <path d="M3.5 7h7" />
      <circle strokeLinecap="square" cx={7} cy={7} r={7} />
      <path strokeLinecap="square" d="M7.233 3.733L10.5 7l-3.267 3.267" />
    </g>
  </StyledIcon>
)

CircleRightArrow.needsWork = true
CircleRightArrow.displayName = 'CircleRightArrow'
export default CircleRightArrow
